module.exports = __webpack_public_path__ + "img/PlusIcon.d08bc988.svg";